<template>
    <footer class="footer" style="padding:0 0 3rem 0;">
        <hr style="border-top: 0.0625rem solid rgb(244 245 247 / 10%);">
        <div class="container">
            <div class="row align-items-center justify-content-md-between">
                <div class="col-md-6">
                    <div>
                        <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
                            <img src="img/brand/logo.png" alt="logo">
                        </router-link>
                    </div>
                    <div class="copyright">
                        동작 본사 | 서울특별시 동작구 현충로 153 상가동 211호
                        <br>대표전화 02-3280-2825 | 팩스 02-3080-2826
                        <br> 
                        <br>&copy; 2024 DAOM, ALL RIGHTS RESERVED                   
                    </div>
                </div>
                <div class="col-md-6">
                    <ul class="nav nav-footer justify-content-end">
                        <li class="nav-item">
                            <a href="/location" class="nav-link"  rel="noopener">오시는 길</a>
                        </li>
                        <li class="nav-item">
                            <a href="/introduce" class="nav-link"  rel="noopener">기업소개</a>
                        </li>
                        <li class="nav-item">
                            <a href="/organization" class="nav-link"  rel="noopener">사업소개</a>
                        </li>
                        <li class="nav-item">
                            <a href="/qanda"
                               class="nav-link"  rel="noopener">고객센터</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
export default {
  name: 'app-footer',
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
};
</script>
<style>
</style>
